import HTTP from '../libs/HTTP';

export interface IAiPromptSceneOption {
    code: string;
    name: string;
}

export interface IAiPromptTemplate {
    id: number;
    sceneCode: string;
    versionNo: number;
    promptType: 'SYSTEM' | 'USER' | 'REFERENCE' | string;
    title?: string;
    content: string;
    model?: string;
    temperature?: number;
    status: number;
    source?: string;
    summary?: string;
    deleted?: number;
    createTime?: string;
    lastEditTime?: string;
}

export interface IAiPromptFeedback {
    id: number;
    sceneCode: string;
    promptTemplateId?: number;
    promptVersion?: number;
    consultantId?: number;
    tagId?: string;
    tagLabel?: string;
    confidenceScore?: number;
    confidenceValue?: number;
    dataSourceSummary?: string;
    reasoningSummary?: string;
    reason?: string;
    suggestion?: string;
    processed: number;
    summaryBatchId?: number;
    createTime?: string;
    lastEditTime?: string;
}

export interface IAiPromptFeedbackSummary {
    id: number;
    sceneCode: string;
    summaryContent?: string;
    recommendationContent?: string;
    issueTypesJson?: string;
    sourceFeedbackCount: number;
    status: number;
    createTime?: string;
    lastEditTime?: string;
}

export interface IAiPromptTemplateQuery {
    sceneCode?: string;
    promptType?: string;
    status?: number;
}

export interface IAiPromptTemplateSave {
    sceneCode: string;
    promptType: string;
    title?: string;
    content: string;
    model?: string;
    temperature?: number;
    source?: string;
    summary?: string;
}

export interface IAiPromptFeedbackQuery {
    sceneCode?: string;
    processed?: number;
}

class AiPromptService extends HTTP {
    async getPromptTemplateList(queryParam: IAiPromptTemplateQuery, pageNo: number, pageSize: number) {
        const response = await this.post('/ai/prompt/list', queryParam || {}, {
            params: { pageNo, pageSize },
        });
        return response ? response.data : null;
    }

    async createPromptTemplate(payload: IAiPromptTemplateSave) {
        const response = await this.post('/ai/prompt/create', payload);
        return response ? response.data : null;
    }

    async updatePromptTemplate(templateId: number, payload: IAiPromptTemplateSave) {
        const response = await this.put(`/ai/prompt/update/${templateId}`, payload);
        return response ? response.data : null;
    }

    async activatePromptTemplate(templateId: number) {
        const response = await this.post(`/ai/prompt/activate/${templateId}`);
        return response ? response.data : null;
    }

    async archivePromptTemplate(templateId: number) {
        const response = await this.post(`/ai/prompt/archive/${templateId}`);
        return response ? response.data : null;
    }

    async getPromptFeedbackList(queryParam: IAiPromptFeedbackQuery, pageNo: number, pageSize: number) {
        const response = await this.post('/ai/prompt/feedback/list', queryParam || {}, {
            params: { pageNo, pageSize },
        });
        return response ? response.data : null;
    }

    async getPromptFeedbackSummaryList(sceneCode?: string, pageNo?: number, pageSize?: number) {
        const response = await this.get('/ai/prompt/feedback/summary/list', {
            params: { sceneCode, pageNo, pageSize },
        });
        return response ? response.data : null;
    }

    async summarizePromptFeedback(sceneCode?: string) {
        const response = await this.post('/ai/prompt/feedback/summarize', sceneCode ? { sceneCode } : {});
        return response ? response.data : null;
    }
}

export default new AiPromptService();
